import { cn } from "@/lib/utils";

export type ActiveFilterChip = {
  key: string;
  label: string;
  onClear: () => void;
};

/**
 * Removable active-filter pills — plan/30+35.
 * Distinct from AdminFilters selects (labels, not controls).
 */
export function ActiveFilterChips(props: {
  chips: ActiveFilterChip[];
  className?: string;
}) {
  if (props.chips.length === 0) return null;
  return (
    <div
      className={cn(
        "order-20 flex w-full basis-full flex-wrap items-center gap-1.5 px-1 pb-0.5 pt-1",
        props.className,
      )}
      aria-label="Active filters"
    >
      {props.chips.map((chip) => (
        <button
          key={chip.key}
          type="button"
          className={cn(
            "inline-flex max-w-full items-center gap-1 rounded-full border border-[var(--color-primary)]/25",
            "bg-[var(--color-primary)]/10 px-2.5 py-1 text-xs font-medium text-[var(--color-primary)]",
            "transition-colors hover:bg-[var(--color-primary)]/16",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]",
          )}
          title={`Clear ${chip.label}`}
          onClick={chip.onClear}
        >
          <span className="truncate">{chip.label}</span>
          <span aria-hidden className="opacity-70">
            ×
          </span>
        </button>
      ))}
    </div>
  );
}
